<template>
    <section id="footer-banner">
        <div class="footer-img-top" v-if="isMobile == false">
            <img class="adelaide-footer" src="@/assets/Home/Footer_new_3.webp"
                alt="adelaide-footer">
        </div>
        <div class="footer-img-top" v-else>
            <img class="adelaide-footer" src="@/assets/Home/Footer-mobile-new-5.webp"
                alt="adelaide-footer">
        </div>

    </section>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const isMobile = ref(false);

function checkMobile() {
  isMobile.value = window.innerWidth <= 835;
}

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>

<style lang="less" scoped >
#footer-banner {
    .footer-img-top {
        display: flex;
        justify-content: center;
    }
    .adelaide-footer {
        max-height: 221px;
    }
    @media only screen and (max-width:834px) {
        .adelaide-footer {
            max-height: 385px;
        }
    }
    
}
</style>
